import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useAlert } from '../ui/Alert';
// import { Link } from 'react-router-dom';

const MainPage = ({
	children,
	show_header = true,
	headers = {},
	show_breadcrumb = true,
	show_search = false,
}) => {
	const { push } = useAlert();
	useEffect(() => {
		if (sessionStorage.getItem('success')) {
			push({
				success: true,
			});
			sessionStorage.removeItem('success');
		}
	}, []);
	return (
		<>
			<div className="loader-bg">
				<div className="loader-bar"></div>
			</div>
			<div id="pcoded" className="pcoded">
				<div className="pcoded-overlay-box"></div>
				<div className="pcoded-container navbar-wrapper">
					<Header show_search={show_search} />
					<div className="showChat_inner"></div>

					<div className="pcoded-main-container">
						<div className="pcoded-wrapper">
							<Sidebar />
							<div className="pcoded-content">
								<div className="page-header card">
									{show_header && (
										<div className="row align-items-end">
											<div className="col-lg-8">
												<div className="page-header-title">
													{Boolean(headers.icon) && (
														<i
															className={`${headers.icon} bg-c-blue`}
														/>
													)}
													<div className="d-inline">
														{Boolean(
															headers.title
														) && (
															<h5>
																{headers.title}
															</h5>
														)}

														{Boolean(
															headers.description
														) && (
															<span>
																{
																	headers.description
																}
															</span>
														)}
													</div>
												</div>
											</div>
											{show_breadcrumb && (
												<div className="col-lg-4">
													<div className="page-header-breadcrumb">
														<ul className="breadcrumb breadcrumb-padding">
															<li className="breadcrumb-item">
																<a href="/dashboard">
																	<i className="feather icon-home"></i>
																</a>
															</li>
															<li className="breadcrumb-item">
																<a href="/dashboard">
																	Dashboard
																</a>
															</li>
															{headers?.breadcrumbs?.map(
																(e, k) => (
																	<li
																		key={k}
																		className="breadcrumb-item"
																	>
																		<a
																			href={
																				e.link
																			}
																		>
																			{e.title?.toLowerCase()}
																		</a>
																	</li>
																)
															)}
														</ul>
													</div>
												</div>
											)}
										</div>
									)}
								</div>

								<div className="pcoded-inner-content">
									<div className="main-body">
										<div className="page-wrapper">
											<div className="page-body">
												<div className="row">
													<div className="col-sm-12">
														{children}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div id="styleSelector"></div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

MainPage.propTypes = {
	children: PropTypes.node,
	show_header: PropTypes.bool,
	show_breadcrumb: PropTypes.bool,
	headers: PropTypes.shape({
		icon: PropTypes.string,
		title: PropTypes.string,
		description: PropTypes.string,
		breadcrumbs: PropTypes.arrayOf(
			PropTypes.shape({
				link: PropTypes.string,
				title: PropTypes.string.isRequired,
			})
		),
	}),
};

MainPage.defaultProps = {
	show_header: true,
	show_breadcrumb: true,
	headers: {},
};

export default MainPage;
